module.exports = __webpack_public_path__ + "static/media/BA-Snake_infinite.caf359d3.png";